import {useEffect, useState} from 'react';

const DescriptionSearchFilter = ({value, onChange}) => {
    const [local, setLocal] = useState(value);

    useEffect(() => setLocal(value), [value]);

    useEffect(() => {
        const t = setTimeout(() => onChange(local.trim() || ''), 400);
        return () => clearTimeout(t);
    }, [local, onChange]);

    return (
        <section className="filter-card">
            <div className="filter-card__header">
                <div className="filter-card__title">Search</div>
            </div>
            <input
                className="filter-input"
                value={local}
                onChange={e => setLocal(e.target.value)}
                placeholder="Title or notes"
            />
        </section>
    );
};

export default DescriptionSearchFilter;
